import { render, staticRenderFns } from "./EcommerceSocial.vue?vue&type=template&id=cf538558&"
import script from "./EcommerceSocial.vue?vue&type=script&lang=js&"
export * from "./EcommerceSocial.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceSocial.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VDivider,VSlideGroup,VSlideItem})
